import { UserAvatarBadge } from 'app/components/user-avatar-badge';

export function ProfileBadge({
  userId,
  avatarSize,
  showSuperPartageur,
  viewedProfileIsAmbassador,
}: {
  userId: string;
  avatarSize: number;
  showSuperPartageur: boolean;
  viewedProfileIsAmbassador: boolean;
}) {
  return (
    <UserAvatarBadge
      userId={userId}
      avatarSize={avatarSize}
      size={55}
      isSuper={showSuperPartageur}
      isAmbassador={viewedProfileIsAmbassador}
    />
  );
}
